export default __webpack_public_path__ + "assets/thermometer-colder.88b91af5.svg";